/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type HomePageQueryVariables = {|
  product_IsBestseller?: ?boolean,
  slug: string,
|};
export type HomePageQueryResponse = {|
  +category: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +backgroundImage: ?string,
        +categoryIcon: ?string,
      |}
    |}>
  |},
  +productVariants: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +sku: string,
        +variantId: ?string,
        +isAvailable: ?boolean,
        +price: ?string,
        +getPrice: ?string,
        +getOriginalPrice: ?string,
        +featuredImage: ?string,
        +discountedPrice: ?string,
        +discountPercentage: ?string,
        +isInWishlist: ?boolean,
        +product: {|
          +id: string,
          +name: string,
          +rating: ?number,
          +description: ?string,
          +price: any,
          +weight: ?any,
          +discountedPrice: ?any,
          +masterSku: ?string,
          +featuredImage: ?string,
          +collection: ?{|
            +id: string,
            +name: string,
          |},
        |},
      |}
    |}>
  |},
  +collections: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
    +image: ?string,
    +desktopBanner: ?string,
    +mobileBanner: ?string,
  |}>,
  +allTestimonials: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +testimonial: string,
      |}
    |}>
  |},
  +getCatalogueBySlug: ?{|
    +id: string,
    +name: ?string,
    +slug: ?string,
    +file: ?string,
  |},
|};
export type HomePageQuery = {|
  variables: HomePageQueryVariables,
  response: HomePageQueryResponse,
|};
*/


/*
query HomePageQuery(
  $product_IsBestseller: Boolean
  $slug: String!
) {
  category {
    edges {
      node {
        id
        name
        backgroundImage
        categoryIcon
      }
    }
  }
  productVariants(product_IsBestseller: $product_IsBestseller) {
    edges {
      node {
        id
        sku
        variantId
        isAvailable
        price
        getPrice
        getOriginalPrice
        featuredImage
        discountedPrice
        discountPercentage
        isInWishlist
        product {
          id
          name
          rating
          description
          price
          weight
          discountedPrice
          masterSku
          featuredImage
          collection {
            id
            name
          }
        }
      }
    }
  }
  collections {
    id
    name
    image
    desktopBanner
    mobileBanner
  }
  allTestimonials {
    edges {
      node {
        id
        name
        testimonial
      }
    }
  }
  getCatalogueBySlug(slug: $slug) {
    id
    name
    slug
    file
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product_IsBestseller"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featuredImage",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discountedPrice",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CategoryNodeConnection",
    "kind": "LinkedField",
    "name": "category",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoryNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CategoryNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backgroundImage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categoryIcon",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "product_IsBestseller",
        "variableName": "product_IsBestseller"
      }
    ],
    "concreteType": "ProductVariantNodeConnection",
    "kind": "LinkedField",
    "name": "productVariants",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductVariantNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductVariantNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sku",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "variantId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAvailable",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "getPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "getOriginalPrice",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discountPercentage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInWishlist",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductNode",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rating",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weight",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "masterSku",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CollectionNode",
                    "kind": "LinkedField",
                    "name": "collection",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CollectionNode",
    "kind": "LinkedField",
    "name": "collections",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "image",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "desktopBanner",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mobileBanner",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "TestimonialNodeConnection",
    "kind": "LinkedField",
    "name": "allTestimonials",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TestimonialNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TestimonialNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "testimonial",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "PremiumCatalogueNode",
    "kind": "LinkedField",
    "name": "getCatalogueBySlug",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "file",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePageQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomePageQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "506e8d5a2c5fd613603592cfc403f557",
    "id": null,
    "metadata": {},
    "name": "HomePageQuery",
    "operationKind": "query",
    "text": "query HomePageQuery(\n  $product_IsBestseller: Boolean\n  $slug: String!\n) {\n  category {\n    edges {\n      node {\n        id\n        name\n        backgroundImage\n        categoryIcon\n      }\n    }\n  }\n  productVariants(product_IsBestseller: $product_IsBestseller) {\n    edges {\n      node {\n        id\n        sku\n        variantId\n        isAvailable\n        price\n        getPrice\n        getOriginalPrice\n        featuredImage\n        discountedPrice\n        discountPercentage\n        isInWishlist\n        product {\n          id\n          name\n          rating\n          description\n          price\n          weight\n          discountedPrice\n          masterSku\n          featuredImage\n          collection {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n  collections {\n    id\n    name\n    image\n    desktopBanner\n    mobileBanner\n  }\n  allTestimonials {\n    edges {\n      node {\n        id\n        name\n        testimonial\n      }\n    }\n  }\n  getCatalogueBySlug(slug: $slug) {\n    id\n    name\n    slug\n    file\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b5f0390a75a68accd3f0ca00deb80257';

module.exports = node;
